import Providers from './providers';
import './style/global.css';

function App() {
  return <Providers></Providers>;
}

export default App;
